import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { resetSelection } from 'owa-mail-actions';
import { getItemsOrConversationsSelectedText } from 'owa-mail-list-store';
import { getSelectedTableView } from 'owa-mail-list-store';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import strings from 'owa-strings/owa-mail-strings';
var styles = require('./MailListHeaderSecondRow.scss');
var headerStyles = require('../MailListHeader.scss');
var MailListHeaderSelectionRowContent = /** @class */ (function (_super) {
    tslib_1.__extends(MailListHeaderSelectionRowContent, _super);
    function MailListHeaderSelectionRowContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailListHeaderSelectionRowContent.prototype.render = function () {
        return (React.createElement("div", { className: headerStyles.mailListSecondRowCustomContainer, role: "heading", "aria-level": 2 },
            React.createElement("span", { className: styles.customSelectionContainer }, getItemsOrConversationsSelectedText(this.props.tableViewId)),
            React.createElement(Link, { onClick: this.resetSelection },
                strings.clearSelection,
                " ")));
    };
    MailListHeaderSelectionRowContent.prototype.resetSelection = function () {
        resetSelection(getSelectedTableView(), MailListItemSelectionSource.SingleLineClearSelection);
    };
    MailListHeaderSelectionRowContent = tslib_1.__decorate([
        observer
    ], MailListHeaderSelectionRowContent);
    return MailListHeaderSelectionRowContent;
}(React.Component));
export default MailListHeaderSelectionRowContent;
//# sourceMappingURL=MailListHeaderSelectionRowContent.js.map